const MAX_SECONDS = 7 * 86400;
export const reviewFailureCode = code => ['review_rate_limited','review_provider_unavailable','review_timeout',
  'review_connection_failed','review_response_invalid','review_prediction_failed','review_configuration_error',
  'review_application_failed'].includes(code) ? code : 'review_failed';
const number = (value, max = MAX_SECONDS) => typeof value === 'number' && Number.isFinite(value)
  ? Math.max(0, Math.min(max, value)) : 0;
export function reviewMeasurements(review) {
  const start = typeof review.prepared_at === 'string' ? Date.parse(review.prepared_at) : NaN;
  const finish = typeof review.finished_at === 'string' ? Date.parse(review.finished_at) : NaN;
  const duration = Number.isFinite(start) && Number.isFinite(finish) && finish >= start
    ? number((finish - start) / 1000) : undefined;
  return { deferred_retry_count: Math.floor(number(review.deferred_retry_count, 3)),
    retry_wait_seconds: number(review.retry_wait_seconds),
    ...(Number.isInteger(review.last_failure_status) && review.last_failure_status >= 400 && review.last_failure_status <= 599
      ? { status_code: review.last_failure_status } : {}),
    ...(['prediction_create','prediction_poll','prediction_result','response_parse','response_validate',
      'review_apply','configuration','unknown'].includes(review.last_failure_operation)
      ? { event_source: `review_${review.last_failure_operation}` } : {}),
    ...(duration === undefined ? {} : { review_duration_seconds: duration }) };
}
